import React from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-datepicker';
import DatePicker from 'react-datepicker';
import '../Public/css/common.scss';

const CommonDateTimePicker = ({ selected, onChange, showTimeSelect, className, dateFormat, timeIntervals, placeholderText, minDate, maxDate, timeFormat, showTimeSelectOnly, disabled, dateRange, isClearable, startDate, endDate, minTime, maxTime, onBlur, placement }) => {
    return (
        <div className={className}>
            {!dateRange ?
                <DateTimePicker
                    selected={selected}
                    onChange={onChange}
                    showTimeSelect={showTimeSelect}
                    dateFormat={dateFormat}
                    timeIntervals={timeIntervals}
                    placeholderText={placeholderText}
                    minDate={minDate}
                    maxDate={maxDate}
                    timeFormat={timeFormat}
                    showTimeSelectOnly={showTimeSelectOnly}
                    disabled={disabled}
                    isClearable={isClearable}
                    minTime={minTime}
                    maxTime={maxTime}
                    popperPlacement={placement}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                /> : <DatePicker
                    selected={selected}
                    onChange={onChange}
                    startDate={startDate}
                    endDate={endDate}
                    minDate={minDate}
                    maxDate={maxDate}
                    selectsRange
                    isClearable={isClearable}
                    placeholderText={placeholderText}
                    dateFormat={dateFormat}
                    onBlur={onBlur}
                    popperPlacement={placement}
                    disabled={disabled}
                />
            }
        </div>
    );
};

CommonDateTimePicker.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
};

CommonDateTimePicker.defaultProps = {
    className: "",
    selected: "",
    dateFormat: "dd-MM-yyyy",
    timeIntervals: 15,
    placeholderText: "Select date and time",
    minDate: new Date(),
    maxDate: "",
    className: "custom-datepicker",
    showTimeSelect: true,
    timeFormat: "HH:mm:ss a",
    showTimeSelectOnly: false,
    disabled: false,
    selectsRange: true,
    dateRange: false,
    isClearable: false,
    startDate: null,
    endDate: null,
    maxTime: "",
    minTime: "",
    placement: "bottom",
    onBlur: () => { },
}

export default CommonDateTimePicker;
